module.exports = __webpack_public_path__ + "static/media/expiring-soon-lease-icon.0a47e21e.svg";